import { ProductCategoryEnum } from "../../enums/product-category.enum";
import { Product } from "../product.interface";

export interface TireProduct extends Product {
  family?: string;
  tireSeason: TireSeasonType;
  width: string;
  height: string;
  radius: string;
  runflat: boolean;
  extraload: boolean
  threePMSF: boolean
  noiseLevel: number
  noiseCategory: NoiseCategory
  wetGrip: WetGrip
  rollingResistance: RollingResistance
  speedIndex: string
  loadIndex: string
  efficiency: Efficiency;
  ecotax: number;
}
export interface ProductListItem {
  productId: number;
  productName: string;
  productCode: string;
}

export interface ProductItemCategoryId extends ProductListItem {
  productCategoryId: ProductCategoryEnum;
}

export enum TireSeasonType {
  WINTER = 0,
  SUMMER = 1,
  ALL_SEASON = 2
}

export enum RollingResistance {
  A = 1,
  B = 2,
  C = 3,
  D = 4,
  E = 5
}

export enum Efficiency {
  A = 1,
  B = 2,
  C = 3,
  D = 4,
  E = 5
}

export enum NoiseCategory {
  A = 1,
  B = 2,
  C = 3
}

export enum WetGrip {
  A = 1,
  B = 2,
  C = 3,
  D = 4,
  E = 5
}


export type TireBrandCategory =
  | 'Destacados'
  | 'Economica'
  | 'Quality'
  | 'Premium';

export interface TireBrandsResponse {
  brands: Record<TireBrandCategory, string[]>;
}

